import * as React from "react";
import { eBranches } from "../../../../contracts";
import { Scoreboards } from "../../../../constants";
import { Scoreboard } from "../Scoreboard";
import { MiniTeamsScore } from "../MiniTeamsScore";
export const MiniScore = (props) => Scoreboards[eBranches[props.sportId]]
    ? React.createElement(Scoreboard, Object.assign({}, props.scoreboard))
    : React.createElement(MiniTeamsScore, { score1: props.score1, score2: props.score2, componentPrefix: props.componentPrefix });
//# sourceMappingURL=MiniScore.js.map